import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, useNavigate } from "react-router-dom";
import "nprogress/nprogress.css";
import * as serviceWorker from "src/serviceWorker";
import "./index.css";
import App from "./App";
import { Auth0Provider as Auth0ProviderWithRedirectCallback } from "@auth0/auth0-react";
import { callbackUri } from "./auth.config";
import { SidebarProvider } from "src/contexts/SidebarContext";

function Auth0ProviderWithHistory({ children }) {
  const navigate = useNavigate();

  const onRedirectCallback = (appState) => {
    navigate(appState?.returnTo || "/");
  };

  return (
    <Auth0ProviderWithRedirectCallback
      domain={process.env.REACT_APP_AUTH0_DOMAIN}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: callbackUri,
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
        scope: "openid profile email offline_access",
      }}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      useRefreshTokensFallback={false}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0ProviderWithRedirectCallback>
  );
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <HelmetProvider>
    <BrowserRouter>
      <Auth0ProviderWithHistory>
        <SidebarProvider>
          <App />
        </SidebarProvider>
      </Auth0ProviderWithHistory>
    </BrowserRouter>
  </HelmetProvider>
);

serviceWorker.unregister();
